module.exports = __webpack_public_path__ + "static/media/stroopwafel.b2331654.svg";